import BrazilianRealEstateFundContext from "components/company/v3/context/BrazilianRealEstateFundContext";
import { useContext } from "react";

export default function useBrazilianRealEstateFundIssuer() {
  const brazilanRealEstateFundIssuer = useContext(BrazilianRealEstateFundContext);

  if (!brazilanRealEstateFundIssuer) {
    throw new Error("No root issuer found. Make sure you're using this hook inside a issuer's context");
  }
  return brazilanRealEstateFundIssuer;
}
